import api from '@/api';

import { API_BASE_URL } from '..';
import { ZipCodeResult } from './ZipCodes.types';

const CONTROLLER_URL = `${API_BASE_URL}/zip-codes`;

export async function getZipcCodeData(zipCode: string): Promise<ZipCodeResult> {
  const result = (await api.get(
    `${CONTROLLER_URL}?zip-code=${zipCode}`,
    null,
  )) as unknown;

  return result as ZipCodeResult;
}
